import { useMutation } from "react-query";
import http from "infra/http";
import { OrcamentoDadosForm } from "../typings";

function useSaveOrcamento(id?: string) {
  return useMutation(
    (data: OrcamentoDadosForm) => {
      if (id) {
        return http.put<{ id: string }>(`/v1/orcamento/${id}`, data);
      }
      return http.post<{ id: string }>(`/v1/orcamento`, data);
    },
    { retry: false }
  );
}

export default useSaveOrcamento;
